export enum SchedulingView {
    Employee = 'employee',
    Project = 'project'
}
